import { omit } from 'lodash';
import type { ParsedUrlQuery } from 'querystring';

export const getQueryFromURL = (url: string): ParsedUrlQuery => {
	const urlSplit = url.split('?');
	const query = urlSplit[1];

	const params = new URLSearchParams(query);
	const paramsObject: { [key: string]: string } = {};

	for (const [key, value] of params.entries()) {
		paramsObject[key] = value;
	}

	return omit(paramsObject, 'page');
};
